import axios from "axios";
import { getUserId } from "../utils/getUserId";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const userId = getUserId();
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    config.headers = config.headers || {};

    if (userId) {
      config.headers["X-User-Id"] = userId;
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;